import { render } from "./CancelPage.vue?vue&type=template&id=6dda19ca&scoped=true&ts=true"
import script from "./CancelPage.vue?vue&type=script&lang=ts"
export * from "./CancelPage.vue?vue&type=script&lang=ts"

import "./CancelPage.vue?vue&type=style&index=0&id=6dda19ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dda19ca"]])

export default __exports__